<ng-container>
  <ng-container
    *ngIf="
      tileIDInFocusLineDetails?.lineTileType === isLine ||
        tileIDInFocusLineDetails?.lineTileType === isExisting;
      else nonLineTile
    "
  >
    <div *ngIf="tileIDInFocusLineDetails?.selectedMsisdn">
      <h3 class="m-t-lg inline-block m-r-xs">
        {{ tileIDInFocusLineDetails?.selectedMsisdn | phone }}
      </h3>
    </div>
    <h4 class="m-t-lg inline-block m-r-xs" *ngIf="!isUpgrade">
      {{ aemContent?.line }} {{ tileIDInFocusLineDetails?.currentLineNumber }}
    </h4>
    <span *ngIf="!tileIDInFocusLineDetails?.isUpgrade"> / {{ currentVoiceLineCount }}</span>
  </ng-container>
  <ng-template #nonLineTile>
    <h4 class="m-t-lg inline-block m-r-xs">
      Device {{ tileIDInFocusLineDetails?.currentLineNumber }}
    </h4>
    <span> / {{ nonLineItemCount }}</span>
  </ng-template>
  <p *ngIf="tileIDInFocusLineDetails?.lineTileType === isExisting" class="small m-t-xs">
    {{ aemContent?.existingLine }}
  </p>
  <p *ngIf="cartHasOnlyDevice" class="small m-t-lg">{{ aemContent?.deviceNeedsAPlan }}</p>
  <p *ngIf="cartHasOnlyPlan" class="small m-t-xs">{{ aemContent?.lineNeedsADevice }}</p>
  <p *ngIf="needPlanAndDevice" class="small m-t-xs">
    1 {{ aemContent?.lineNeedsPlanAndDeviceSelection }}
  </p>

  <div class="row tiles">
    <div class="col-12 m-t-md">
      <div class="tiles-container">
        <ng-container *ngFor="let tile of allLineDetails">
          <a
            id="{{ tile?.tileId }}"
            (click)="navigateToSelectedTile(tile)"
            [ngClass]="{
              'tile-item': !(isUpgrade && tile?.lineTileType === 2 && tile?.isUpgrade === false),
              selected: tile?.tileId === tileIDInFocusLineDetails?.tileId,
              hidden: isUpgrade && tile?.lineTileType === 2 && tile?.isUpgrade === false,
              complete:
                tile?.isLineSetupCompleted && !(tile?.lineTileType === isExisting) && !isUpgrade,
              disabled:
                !tileIDInFocusLineDetails?.isLineSetupCompleted && allLineDetails.length > 1,
              alternate: !(tile?.lineTileType === isExisting),
            }"
          >
            <span class="tile-content">
              <p
                class="small"
                *ngIf="
                  tile?.lineTileType === isLine || tile?.lineTileType === isExisting;
                  else noPlanNeeded
                "
              >
                {{ aemContent?.line }} {{ tile?.currentLineNumber }}
              </p>
              <ng-template #noPlanNeeded>
                <p class="small">SD {{ tile?.currentLineNumber }}</p>
              </ng-template>
            </span>
          </a>
        </ng-container>
      </div>
    </div>
    <div class="col-12 m-t-sm" *ngIf="!tileIDInFocusLineDetails?.isUpgrade && !isUpgrade">
      <p class="xsmall">
        <span class="m-r-md bold">{{ aemContent?.lines }}</span> {{ remainingLines }}/
        {{ maxVoiceLineCount }} {{ totalLinesRemaining }}
      </p>
    </div>
  </div>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</ng-container>
